<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

    <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombres')">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Información del Representante Legal
        </md-card-header>
        <md-card-content>
          <p align="justify">
            Apellido(s) y Nombre(s) del Mancomuno *
          </p>
          <div>            

            <md-field :class="getValidationClass('nombres')">
              <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.nombres" autocomplete="off" />
              <span class="md-error" v-if="!$v.form.nombres.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.nombres.minLength">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.nombres.alpha">Formato inválido</span>
            </md-field>                 

          </div>
        </md-card-content> 
      </md-card>             

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidad')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Documento de identidad *
        </md-card-header>
        <md-card-content class="md-layout">
          
          <div>
            
            <div>
              <md-checkbox v-model="form.docIdentidad" value="DNI">DNI</md-checkbox>
              <md-checkbox v-model="form.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
              <md-checkbox v-model="form.docIdentidad" value="PAS">Pasaporte</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass('docIdentidad')">
              <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
            </div>               

          </div>
        </md-card-content> 
      </md-card>    

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('nrodocIdentidad')">
        <md-card-header  class="md-layout md-alignment-center-left justify">
          Número de documento de identidad *
        </md-card-header>
        <md-card-content>

          <div>
            
            <md-field :class="getValidationClass('nrodocIdentidad')">
              <md-input type="text" id="nrodocIdentidad" name="nrodocIdentidad" placeholder="Su respuesta" v-model="form.nrodocIdentidad" autocomplete="off" />
              <span class="md-error" v-if="!$v.form.nrodocIdentidad.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.valDoc">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.minLength">Formato inválido</span>  
            </md-field> 

          </div>
        </md-card-content> 
      </md-card>                   

      <div>
        <md-button class="md-raised" @click="back">Atras</md-button>  
        <md-button class="md-raised" type="submit">Siguiente</md-button>  
      </div>    

    </div>
  </form>
</template>

<style>

</style>

<script>

import { validationMixin } from 'vuelidate'
import { alpha, valDoc } from '../variables'
import {
  required,
  minLength,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Form23',
  data: () => ({
    form:{
      docIdentidad: null,
      nombres: null,
      nrodocIdentidad: null,
    }
  }),
  mounted: function(){
      this.form = this.$store.state.form.form23
  },  
  validations: {
    form: {
      nombres: {
        required,
        minLength: minLength(3),
        alpha
      },
      docIdentidad: {
        required,
        minLength: minLength(3)
      },
      nrodocIdentidad: {
        required,
        valDoc,
        minLength: minLength(3)
      }
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form23
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        
        this.$emit('setSaveForm', {id:"23", form: this.form, index: "4"});
        
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  }    
}
</script>
